import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { updateClientStatus, getClients } from '../../actions/Clients';
import {
  AppBar,
  IconButton,
  Paper,
  Snackbar,
  RaisedButton
} from 'material-ui';
import ContentBackspace from 'material-ui/svg-icons/content/backspace';

const styles = {
  container: {
    maxWidth: 600,
    margin: '20px auto',
    padding: 20,
  },
  field: {
    marginBottom: 15,
  },
  title: {
    fontWeight: 'bold',
    marginBottom: 4,
  },
  value: {
    marginBottom: 10,
  }
};

class ClientDetails extends Component {
  static contextTypes = {
    router: PropTypes.object,
  };

  static propTypes = {
    client: PropTypes.object,
    updateClientStatus: PropTypes.func,
    getClients: PropTypes.func,
    params: PropTypes.object,
  };

  state = {
    message: null,
  };

  goBack = () => {
    this.context.router.push('/clients');
  };

  toggleStatus = () => {
    const { client, updateClientStatus, getClients } = this.props;
    const newStatus = client.invoiceStatus === "active" ? 0 : 1;

    updateClientStatus(client.user_id, newStatus)
      .then(() => {
        this.setState({
          message: `Client status updated to ${newStatus === 1 ? "active" : "inactive"}!`,
        });

        getClients([], 0, 30);
      })
      .catch((err) => {
        this.setState({ message: err.message });
      });
  };

  clearMessage = () => {
    this.setState({ message: null });
  };

  render() {
    const { client } = this.props;
    const { message } = this.state;

    if (!client) {
      return <div>Client not found</div>;
    }

    return (
      <div>
        <AppBar
          title="Client Details"
          iconElementLeft={
            <IconButton tooltip="Back" onClick={this.goBack}>
              <ContentBackspace />
            </IconButton>
          }
        />

        <Paper style={styles.container}>
          <div style={styles.field}>
            <div style={styles.title}>Display Name:</div>
            <div style={styles.value}>{client.display_name}</div>
          </div>

          <div style={styles.field}>
            <div style={styles.title}>Email:</div>
            <div style={styles.value}>{client.email}</div>
          </div>

          <div style={styles.field}>
            <div style={styles.title}>User ID:</div>
            <div style={styles.value}>{client.user_id}</div>
          </div>

          <div style={styles.field}>
            <div style={styles.title}>Invoice Status:</div>
            <div style={styles.value}>{client.invoiceStatus}</div>
          </div>

          <RaisedButton
            label={client.invoiceStatus === "active" ? "Deactivate Client" : "Activate Client"}
            secondary={client.invoiceStatus === "active"}
            primary={client.invoiceStatus !== "active"}
            fullWidth
            onClick={this.toggleStatus}
          />
        </Paper>

        <Snackbar
          message={message || ""}
          open={!!message}
          autoHideDuration={2000}
          onRequestClose={this.clearMessage}
        />
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  const { clientId } = ownProps.params;

  const client = Object.values(state.clientsReducer && state.clientsReducer.clients || {}).find(
    (client) => String(client.id) === String(clientId)
  );

  return {
    client,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    updateClientStatus: (userId, status) => dispatch(updateClientStatus(userId, status)),
    getClients: (filters, pageStart, pageLength) => dispatch(getClients(filters, pageStart, pageLength)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ClientDetails);
